"use strict";
exports.__esModule = true;
var TextRow_1 = require("./TextRow");
exports.TextRow = TextRow_1["default"];
var RoundShape_1 = require("./RoundShape");
exports.RoundShape = RoundShape_1["default"];
var RectShape_1 = require("./RectShape");
exports.RectShape = RectShape_1["default"];
var TextBlock_1 = require("./TextBlock");
exports.TextBlock = TextBlock_1["default"];
var MediaBlock_1 = require("./MediaBlock");
exports.MediaBlock = MediaBlock_1["default"];
exports.textRow = TextRow_1["default"];
exports.round = RoundShape_1["default"];
exports.rect = RectShape_1["default"];
exports.text = TextBlock_1["default"];
exports.media = MediaBlock_1["default"];



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-placeholder/lib/placeholders/index.js
// module id = 887
// module chunks = 57